import DropdownField from '../../../../../../../../elements/DropdownField'
import { useState, useEffect } from 'react'
import { useSearchContext } from '../../../../../../../../../providers/SearchContext'
import IconCalendar from '/public/icons/icon-calendar.svg'
import isEqual from 'lodash-es/isEqual'
import dynamic from 'next/dynamic'

const Calendar = dynamic(
  () => import('../../../../../../../../elements/form/Calendar'),
  {
    ssr: false,
    loading: () => <div>Loading calendar...</div>
  }
)

const Departure = ({
  form: { setFieldValue },
  variant,
  width,
  property,
  blockedDates,
  label,
  ...props
}) => {
  const { search, initialValues, setSearch, offsetable } = useSearchContext()
  const [close, setClose] = useState(false)
  const [endDate, setEndDate] = useState(
    (offsetable === 0 && search?.endDate) || initialValues?.endDate
  )

  const endDateString = search.endDate && search.endDate.format('MMM D')

  useEffect(() => {
    if (
      search.endDate &&
      search.startDate &&
      search.endDate.isBefore(search.startDate, 'day')
    ) {
      setEndDate(initialValues.startDate)
    }
  }, [search.startDate])

  useEffect(() => {
    setClose(true)
    setTimeout(() => setClose(false), 10)
    setFieldValue('endDate', endDate)
    setTimeout(
      () =>
        setSearch &&
        setSearch((prevState) => ({
          ...prevState,
          endDate: endDate
        })),
      10
    )
  }, [endDate])

  const handleClear = () => {
    setSearch &&
      setSearch(() => ({ ...search, endDate: initialValues?.endDate }))
  }

  return (
    <DropdownField
      isActive={search.endDate}
      prependIcon={<IconCalendar width={26} height={26} />}
      triggerClose={close}
      onClear={handleClear}
      disabled={!property.is_active}
      variant={[...variant, 'right']}
      disableApply={isEqual(search.endDate, endDate)}
      disableClear={search.endDate === null}
      value={search.endDate ? endDateString : label}
      {...props}
    >
      <div
        style={{
          width: width,
          display: 'flex',
          justifyContent: 'center'
        }}
      >
        <Calendar
          key={
            blockedDates && blockedDates.length
              ? blockedDates.map((d) => (d.format ? d.format('YYYY-MM-DD') : d))
              : 'none'
          }
          numberOfMonths={1}
          type="endDate"
          startDate={endDate}
          blockedDates={blockedDates}
          setStartDate={setEndDate}
          minNights={property?.terms?.minNights || 7}
        />
      </div>
    </DropdownField>
  )
}

export default Departure
